export default [
    {
        name: 'GENERAL',
        id: '0',
        description: 'entity.general'
    },
    {
        name: 'PATIENT',
        id: '1',
        description: 'entity.patient'
    },
    {
        name: 'REQUEST',
        id: '2',
        description: 'entitiy.request'
    },
    {
        name: 'CASE',
        id: '3',
        description: 'entity.case'
    },
    {
        name: 'SAMPLE',
        id: '4',
        description: 'entity.sample'
    },
    {
        name: 'PORTION',
        id: '5',
        description: 'entity.portion'
    },
    {
        name: 'SUBPORTION',
        id: '6',
        description: 'entity.subportion'
    }
]
